import React, { FunctionComponent, KeyboardEventHandler, useRef } from "react";

import { AlignItems, CheckBoxField, FlexDirection, FlexGrow, Layout, SpacingSize } from "@multiweb/reactComponents";
import { bemClassNames, DataRowElementSiblings, getDataRowSibling, Key, TAB_INDEX_FOCUSABLE_ONLY } from "@multiweb/reactUtils";
import { Role } from "@multiweb/uiShared/Role";
import { GRID_PARTICIPANTS_ITEM_CLASS_NAME } from "../GridParticipantsItem/constants";
import { RoleUserRowProps } from "../RoleUserRow/RoleUserRow";

export type RoleUserRowComponentProps = RoleUserRowProps & {
    /** Příznak, zda je záznam zaškrtnut. */
    isChecked?: boolean;
    /** Akce pro zaškrtnutí záznamu. */
    toggleChecked: () => void;
    /** Děti pro vykreslení. */
    children?: React.ReactElement[];
};

const classNames = bemClassNames("role-user-row");

export const RoleUserRowComponent: FunctionComponent<RoleUserRowComponentProps> = ({
    isChecked,
    toggleChecked,
    children,
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const handleOnKeyPressed: KeyboardEventHandler = (event) => {
        const { key } = event;

        switch (key) {
            case Key.ArrowDown: {
                event.preventDefault();
                const newFocusElement = document.activeElement?.nextElementSibling as HTMLElement;

                if (!newFocusElement) {
                    const elem = containerRef.current?.closest(`.${GRID_PARTICIPANTS_ITEM_CLASS_NAME()}`) as HTMLElement;
                    const nextParentRow = getDataRowSibling(DataRowElementSiblings.nextElementSibling, elem)?.firstChild as HTMLElement;

                    if (nextParentRow) {
                        nextParentRow.focus();
                    }

                    return true;
                }

                newFocusElement.focus();
                return true;
            }
            case Key.ArrowUp: {
                event.preventDefault();
                const newFocusElement = document.activeElement?.previousElementSibling as HTMLElement;

                if (!newFocusElement) {
                    const elem = containerRef.current?.closest(`.${GRID_PARTICIPANTS_ITEM_CLASS_NAME()}`)?.firstChild as HTMLElement;

                    if (elem) {
                        elem.focus();
                    }
                    return true;
                }

                newFocusElement.focus();
                return true;
            }
            case Key.Space: {
                event.preventDefault();
                toggleChecked();
                return true;
            }
        }
        return false;
    };

    return (
        <div className={classNames()} onKeyDown={handleOnKeyPressed} tabIndex={TAB_INDEX_FOCUSABLE_ONLY} role={Role.row} onClick={toggleChecked} ref={containerRef} aria-selected={isChecked ?? false} >
            <Layout alignItems={AlignItems.center}>
                <Layout spacingSizeRight={SpacingSize.m} alignItems={AlignItems.center}>
                    <CheckBoxField
                        value={isChecked}
                        disabled={false}
                        qa={"userRowCheckbox"}
                    />
                </Layout>
                <Layout flexGrow={FlexGrow.one} flexDirection={FlexDirection.column}>
                    { children }
                </Layout>
            </Layout>
        </div>
    );
};
